// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_H0KGc","foot_link":"index_foot_link_Y-Bmg","list":"index_list_TE4B8","link":"index_link_Z9tcP","copyright":"index_copyright_tcS5i"};